import { jsxs as e, jsx as d } from "react/jsx-runtime";
const c = () => /* @__PURE__ */ e(
  "svg",
  {
    id: "a646667d-a6c8-4cdd-ad77-5ddfe07339cc",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    children: [
      /* @__PURE__ */ d("defs", { children: /* @__PURE__ */ d("clipPath", { id: "a233c5af-2f19-4825-bb66-70bca0dd720b", children: /* @__PURE__ */ d(
        "rect",
        {
          className: "b0aae99b-ec73-4206-9ff9-2051d34ed48b",
          width: "24",
          height: "24"
        }
      ) }) }),
      /* @__PURE__ */ d("g", { className: "bc890c0d-46cd-4708-9043-044567496afa", children: /* @__PURE__ */ d(
        "path",
        {
          className: "bf127c32-23db-4fbe-b18a-5e7911219efe",
          d: "M21,17H3v1H21Zm0-6H3v1H21Zm0-5H3V5H21Z"
        }
      ) })
    ]
  }
);
export {
  c as default
};
